import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconEdit, IconX, IconChartBar, IconTrash } from "@tabler/icons-react";
import { SystemConstant, LangConstant } from "const";
import EditMessageDialog from "./EditMessageDialog";
import { useBotMessageUpdate } from "hooks";
import MessageStatisticDialog from "./MessageStatisticDialog";
import ConfirmDialog from "./ConfirmDialog";

const MessageAction = ({ message, refetchList }) => {
  const { t: getLabel } = useTranslation();
  const status = message ? message.status : SystemConstant.BOT_MESSAGE_STATUS.PENDING.status;

  const { updateBotMessage } = useBotMessageUpdate();

  const [isOpenEditMessage, setIsOpenEditMessage] = useState(false);
  const [isOpenMessageStatistic, setIsOpenMessageStatistic] = useState(false);
  const [isOpenConfirmDelete, setIsOpenConfirmDelete] = useState(false);
  const [isOpenConfirmCancle, setIsOpenConfirmCancle] = useState(false);

  const handleCancle = () => {
    updateBotMessage({
      bot_message_id: message.id,
      status: SystemConstant.BOT_MESSAGE_STATUS.CANCELED.status,
      onClose: () => {
        refetchList();
      },
      messageSucess: getLabel(LangConstant.TXT_MEDIA_CANCEL_SCHEDULE),
    });
  };

  const handleDelete = () => {
    updateBotMessage({
      bot_message_id: message.id,
      state: SystemConstant.STATE.DELETED,
      onClose: () => {
        refetchList();
      },
      messageSucess: getLabel(LangConstant.TXT_MEDIA_DELETED),
    });
  };

  const iconButtonStyle = {
    border: "1px solid var(--tblr-border-color)",
    borderRadius: "8px",
    width: "32px",
    height: "32px",
    backgroundColor: "var(--tblr-bg-surface-secondary)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const boxActionStyle = {
    border: "1px solid var(--tblr-border-color)",
    borderRadius: "8px",
    width: "fit-content",
    padding: "0 12px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    cursor: "pointer",
  };

  const StatusLabel = () => {
    switch (status) {
      case SystemConstant.BOT_MESSAGE_STATUS.PENDING.status:
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={iconButtonStyle}
              title={getLabel(LangConstant.TXT_EDIT_INFO)}
              onClick={() => {
                setIsOpenEditMessage(true);
              }}
            >
              <IconEdit size={18} />
            </div>
            <div style={iconButtonStyle} title={getLabel(LangConstant.TXT_MEDIA_CONFIRM_CANCEL_TITLE)} onClick={() => setIsOpenConfirmCancle(true)}>
              <IconX size={18} />
            </div>
          </div>
        );
      case SystemConstant.BOT_MESSAGE_STATUS.SUCCESS.status:
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={iconButtonStyle}
              title={getLabel(LangConstant.TXT_MEDIA_STATISTIC_TITLE)}
              onClick={() => {
                setIsOpenMessageStatistic(true);
              }}
            >
              <IconChartBar size={18} />
            </div>
          </div>
        );
      case SystemConstant.BOT_MESSAGE_STATUS.CANCELED.status:
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={boxActionStyle}
              title={getLabel(LangConstant.TXT_MEDIA_RESEND)}
              onClick={() => {
                setIsOpenEditMessage(true);
              }}
            >
              {getLabel(LangConstant.TXT_MEDIA_RESEND)}
            </div>
            <div style={iconButtonStyle} title={getLabel(LangConstant.TXT_MEDIA_CONFIRM_DELETE_TITLE)} onClick={() => setIsOpenConfirmDelete(true)}>
              <IconTrash size={18} />
            </div>
          </div>
        );
      case SystemConstant.BOT_MESSAGE_STATUS.DRAFT.status:
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={boxActionStyle}
              onClick={() => {
                setIsOpenEditMessage(true);
              }}
            >
              {getLabel(LangConstant.TXT_MEDIA_CONTINUE)}
            </div>
          </div>
        );
      default:
        return (
          <span className="badge bg-danger" style={{ width: "130px", cursor: "default" }}>
            {getLabel(SystemConstant.BOT_MESSAGE_STATUS.FAILED.label)}
          </span>
        );
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
      <StatusLabel />

      <ConfirmDialog
        open={isOpenConfirmDelete}
        onClose={() => setIsOpenConfirmDelete(false)}
        onSubmit={handleDelete}
        title={getLabel(LangConstant.TXT_MEDIA_CONFIRM_DELETE_TITLE)}
        content={getLabel(LangConstant.TXT_MEDIA_CONFIRM_DELETE_CONTENT)}
        submit={getLabel(LangConstant.TXT_MEDIA_CONFIRM_BTN)}
        exit={getLabel(LangConstant.L_CANCEL)}
        color="error"
      />

      <ConfirmDialog
        open={isOpenConfirmCancle}
        onClose={() => setIsOpenConfirmCancle(false)}
        onSubmit={handleCancle}
        title={getLabel(LangConstant.TXT_MEDIA_CONFIRM_CANCEL_TITLE)}
        content={getLabel(LangConstant.TXT_MEDIA_CONFIRM_CANCEL_CONTENT)}
        submit={getLabel(LangConstant.TXT_MEDIA_CONFIRM_BTN)}
        exit={getLabel(LangConstant.L_CANCEL)}
        color="error"
      />

      {message && (
        <EditMessageDialog
          message={message}
          open={isOpenEditMessage}
          onClose={() => {
            setIsOpenEditMessage(false);
          }}
          refetchList={refetchList}
        />
      )}

      {message && (
        <MessageStatisticDialog
          message={message}
          open={isOpenMessageStatistic}
          onClose={() => {
            setIsOpenMessageStatistic(false);
          }}
        />
      )}
    </div>
  );
};

export default MessageAction;
